<form #marketplaceForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
    @if (isLoadingData) {
        <div class="flex justify-center">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    }
    @else {
        <div class="grid grid-cols-3 gap-4">
            <div class="col-span-2 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <input pInputText disabled #nom="ngModel" id="nom" name="nom" [(ngModel)]="formMarketplace.nom" fluid autocomplete="off" required />
                    <label for="nom">Nom du marketplace</label>
                </p-floatlabel>
            </div>

            <div class="col-span-1 flex row items-center gap-2 mb-2">
                <p-toggleswitch [(ngModel)]="formMarketplace.actif" name="actif" id="actif" ></p-toggleswitch> Active
            </div>

            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <input pInputText disabled #pays_code="ngModel" id="pays_code" name="pays_code" [(ngModel)]="formMarketplace.pays_code" fluid required />
                    <label for="pays_code">Code du pays</label>
                </p-floatlabel>
            </div>

            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <input pInputText [pAutoFocus]="true" #langue="ngModel" id="langue" name="langue" [(ngModel)]="formMarketplace.langue" fluid required />
                    <label for="langue">Langue</label>
                </p-floatlabel>
            </div>

            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <input pInputText #prefixe_sku="ngModel" id="prefixe_sku" name="prefixe_sku" [(ngModel)]="formMarketplace.prefixe_sku" fluid />
                    <label for="prefixe_sku">Préfixe SKU</label>
                </p-floatlabel>
            </div>

            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <input pInputText disabled #devise="ngModel" id="devise" name="devise" [(ngModel)]="formMarketplace.devise" fluid required />
                    <label for="devise">Devise</label>
                </p-floatlabel>
            </div>

            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <p-inputnumber mode="decimal" disabled #taux_change="ngModel" id="taux_change" name="taux_change" [(ngModel)]="formMarketplace.taux_change" fluid required />
                    <label for="taux_change">Taux de change</label>
                </p-floatlabel>
            </div>

            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <p-inputnumber suffix=" %" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" #tva_taux="ngModel" id="tva_taux" name="tva_taux" [(ngModel)]="formMarketplace.tva_taux" fluid required />
                    <label for="tva_taux">Taux TVA</label>
                </p-floatlabel>
            </div>
        </div>
        <div class="grid grid-cols-5 gap-4">
            <div class="col-span-4 flex flex-col justify-center gap-2">
                <h5 class="!m-0">Aspects</h5>
            </div>
            <div class="col-span-1 flex items-end flex-col gap-2">
                <p-button icon="pi pi-plus" type="button" text pTooltip="Ajouter un aspect" tooltipPosition="left" [disabled]="formMarketplace.aspects_noms_key_value && formMarketplace.aspects_noms_key_value.length >= aspectsKeys.length" (click)="addAspect()" />
            </div>
            @for (aspect_nom of formMarketplace.aspects_noms_key_value; track $index; let i = $index) {
                <div class="col-span-2 flex flex-col gap-2">
                    <p-floatlabel variant="in" class="mb-2">
                        <p-select [options]="aspectsKeys" #aspect_nom_key="ngModel" id="aspect_nom_key_{{i}}" name="aspect_nom_key_{{i}}" [(ngModel)]="aspect_nom.key" fluid required>
                            <ng-template let-selectedValue #selectedItem>
                                <span>{{ selectedValue }}</span>
                            </ng-template>
                            <ng-template let-value #item>
                                <span>{{ value }}</span>
                            </ng-template>
                        </p-select>
                        <label for="aspect_nom_key_{{i}}">Clé aspect {{i + 1}}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-2 flex flex-col gap-2">
                    <p-floatlabel variant="in" class="mb-2">
                        <input pInputText #aspect_nom_value="ngModel" pattern="[a-zA-Z0-9_ ]{1,}" id="aspect_nom_value_{{i}}" name="aspect_nom_value_{{i}}" [(ngModel)]="aspect_nom.value" fluid required />
                        <label for="aspect_nom_value_{{i}}">Valeur aspect {{i + 1}}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-1 flex items-end justify-center flex-col gap-2 mb-2">
                    <p-button icon="pi pi-trash" type="button" severity="danger" text pTooltip="Supprimer cet aspect" tooltipPosition="left" (click)="removeAspect(i)" />
                </div>
            }
        </div>

        <div class="grid grid-cols-5 gap-4">
            <div class="col-span-4 flex flex-col gap-2">
                <h5 class="!m-0">Politiques de livraison</h5>
            </div>
            <div class="col-span-1 flex items-end flex-col gap-2">
                <p-button icon="pi pi-plus" type="button" text pTooltip="Ajouter une politique de livraison" tooltipPosition="left" (click)="addDeliveryPolicy()" />
            </div>
            @for (politique_livraison of formMarketplace.politiques_livraison; track $index; let i = $index) {
                <div class="col-span-2 flex flex-col gap-2">
                    <p-floatlabel variant="in" class="mb-2">
                        <input pInputText #politiques_livraison_policy_id="ngModel" pattern="[0-9]{1,}" id="politiques_livraison_policy_id_{{i}}" name="politiques_livraison_policy_id_{{i}}" [(ngModel)]="politique_livraison.policy_id" fluid required />
                        <label for="politiques_livraison_policy_id_{{i}}">ID politique de livraison {{i + 1}}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-2 flex flex-col gap-2">
                    <p-floatlabel variant="in" class="mb-2">
                        <p-inputnumber mode="decimal" suffix=" kg" [minFractionDigits]="2" [maxFractionDigits]="2" #politiques_livraison_poids_max="ngModel" id="politiques_livraison_poids_max_{{i}}" name="politiques_livraison_poids_max_{{i}}" [(ngModel)]="politique_livraison.poids_max" fluid required />
                        <label for="politiques_livraison_poids_max_{{i}}">Poids maximum {{i + 1}}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-1 flex items-end justify-center flex-col gap-2 mb-2">
                    <p-button icon="pi pi-trash" type="button" severity="danger" text pTooltip="Supprimer cette politique de livraison" tooltipPosition="left" (click)="removeDeliveryPolicy(i)" />
                </div>
            }
        </div>

        <div class="grid grid-cols-2 gap-4">
            <div class="col-span-2 flex flex-col gap-2">
                <h5 class="!m-0">Descriptions haute</h5>
            </div>
            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <textarea pTextarea #top_description_neuf="ngModel" rows="5" id="top_description_neuf" name="top_description_neuf" [(ngModel)]="formMarketplace.top_description_neuf" fluid ></textarea>
                    <label for="top_description_neuf">Description haute - Neuf</label>
                </p-floatlabel>
            </div>
            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <textarea pTextarea #top_description_occasion="ngModel" rows="5" id="top_description_occasion" name="top_description_occasion" [(ngModel)]="formMarketplace.top_description_occasion" fluid ></textarea>
                    <label for="top_description_occasion">Description haute - Occasion</label>
                </p-floatlabel>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <div class="col-span-2 flex flex-col gap-2">
                <h5 class="!m-0">Descriptions condition</h5>
            </div>
            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <textarea pTextarea #condition_description_neuf="ngModel" rows="5" id="condition_description_neuf" name="condition_description_neuf" [(ngModel)]="formMarketplace.condition_description_neuf" fluid ></textarea>
                    <label for="condition_description_neuf">Description condition - Neuf</label>
                </p-floatlabel>
            </div>
            <div class="col-span-1 flex flex-col gap-2">
                <p-floatlabel variant="in" class="mb-2">
                    <textarea pTextarea #condition_description_occasion="ngModel" rows="5" id="condition_description_occasion" name="condition_description_occasion" [(ngModel)]="formMarketplace.condition_description_occasion" fluid ></textarea>
                    <label for="condition_description_occasion">Description condition - Occasion</label>
                </p-floatlabel>
            </div>
        </div>

        <div class="flex flex-row justify-between mt-4">
            <p-button label="Annuler" icon="pi pi-times" text severity="danger" (click)="hideDialog()" />
            <p-button label="Sauvegarder" icon="pi pi-save" iconPos="right" type="submit" [disabled]="!marketplaceForm.valid || !hasChanges() || isSendingDatas" [loading]="isSendingDatas" />
        </div>
    }
</form>
